var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right-item-content"},[_c('div',{staticClass:"txt-blue",staticStyle:{"font-size":"18px"}},[_vm._v("客服热线:18236414232")]),_c('div',{staticStyle:{"margin-top":"20px"}},[_vm._v(" 在官方网站、小程序或APP上，注册登录账户后，选择或搜索想要出售的卡种，输入卡号、卡密等信息，系统自动验证卡的有效性与余额。确认无误后，根据平台实时汇率计算可兑换金额，用户可选择提现至绑定的银行卡或第三方支付账户。整个过程需设置短信验证码、支付密码等多重验证环节，保障交易安全。 ")])])])
}]

export { render, staticRenderFns }